import React from 'react';
import Fade from 'react-bootstrap/Fade';
import {
  RULE_TYPES,
  SINGLE_TARGET_RULE_TYPES
} from '../../shared/constants/app_constants';

const modelName = 'form_rule';

const faTypesForValueSetting = ['freeform','singleselect','multiselect','noninput']; //TODO - make sure this works as expected

export default class GeneralTab extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      collapseTargetAttributes: true,
      target_submit_button: this.props.form_rule.metadata?.target_submit_button || false
    };
  }

  renderTypeFunctionInput = () => {
    const formRule = this.props.form_rule;
    return (
      <div className='form-group row'>
        <label 
          className="col-md-4 col-sm-12 col-form-label"
          htmlFor='form_rule[use_type_function]'>Use custom function:
        </label>
        <div className="col-sm-8">
          <input 
            type="hidden" 
            name="form_rule[use_type_function]" 
            value="0" />
          <input 
            type="checkbox"
            className="form-control"
            value="1"
            onChange={this.updateUseCustomFunctionForType}
            checked={!!formRule.use_type_function}
            name="form_rule[use_type_function]" />
        </div>
      </div>
    );
  }

  renderTargetAttributeDropDownForSingle = () => {
    const targetAttributeId = this.props.form_rule.target_attribute_ids.length === 1 ?
    this.props.form_rule.target_attribute_ids[0] : undefined;
    const targetAttribute = this.props.keenform.form_attributes.find(fa => fa.id === targetAttributeId);
    const taName = (targetAttribute !== undefined) ? targetAttribute.name : undefined;
    const targetAttributeEditable = this.props.form_rule.rule_type === RULE_TYPES.VALIDATING
    if (!taName){
      // TODO: this is a use case that currently not built out, will revisit at a later date
      console.error('this form rule has no target attribute selected, should be set in leadup');
      const linkURL = `/dashboard/keenforms/${this.props.form_rule.keenform_id}/form_rules/helper`;
      return <a href={linkURL} className="btn btn-warning">Go back to helper to select target attribute</a>;
    } else {
      return (
      <React.Fragment>
        <label 
          className="col-form-label col-4"
          htmlFor='form_rule[target_attribute_ids]'>Target Attribute:
        </label>
        <div className="col-8">
        { !targetAttributeEditable
          ? <React.Fragment>
            <input
              className='form-control'
              type='text'
              disabled
              value={taName} />
            <input type='hidden' name='form_rule[target_attribute_ids][]' value={targetAttributeId} />
            </React.Fragment>
          : <select
              className='form-control'
              name='form_rule[target_attribute_ids][]'
              defaultValue={targetAttributeId} 
              onChange={this.props.updateAttributeOnEvent}>
              {this.props.keenform.form_attributes.map((fa, index) => <option value={fa.id} key={index}>{fa.label}</option>)}
            </select>
        }
        </div>
      </React.Fragment>
      );
    }
  }

  renderTargetAttributeDropDownForMultiple = () => {
    const keenformAttributes = this.props.keenform.form_attributes.map( fa => {
      return { 
        value: fa.id,
        id: fa.id,
        label: fa.name,
        uuid: fa.uuid,
        selected: this.props.form_rule.target_attribute_ids.includes(fa.id)}
    });
    return (<div className="row">
      <div className="col-12"><strong>Target Attributes</strong></div>
      <div className="col-12">
        {keenformAttributes
          .map(fa => {
            const buttonClass = fa.selected ? 'btn-info' : 'btn-light';
            return (<button 
              type="button"
              key={fa.uuid}
              onClick={() => {this.props.toggleTargetAttribute(fa.id);}}
              className={`btn ${buttonClass}`}>
              { fa.label }
              { fa.selected 
                ? <input type='hidden' name='form_rule[target_attribute_ids][]' value={fa.id} />
                : undefined
              }
            </button>);
          })
        }
        { this.props.form_rule.rule_type == RULE_TYPES.HIDING && this.renderSubmitButtonAsTarget()}
      </div>
    </div>);
  }

  renderSubmitButtonAsTarget = () => {
    const buttonClass = this.state.target_submit_button ? "btn-info" : "btn-light";
    const hiddenInputValue = this.state.target_submit_button ? "1" : "0";
    return (<>
      <button 
        type="button" 
        onClick={() => {this.setState({target_submit_button: !this.state.target_submit_button})}}
        className={`btn ${buttonClass}`}>
          submit button
        </button>
      <input 
        type="hidden"
        name="form_rule[target_submit_button]"
        value={hiddenInputValue}
        />
    </>);
  }

  updateUseCustomFunctionForType = (event) => {
    this.props.updateFormRuleAttributePerParams('use_type_function', event.target.checked);
  }

  render(){
    const formRule = this.props.form_rule;
    const targetSubmitButton = this.state.target_submit_button;
    const showTargetFAErrorMessage = formRule.target_attribute_ids.length === 0 && targetSubmitButton != true;
    const taContainerClass = showTargetFAErrorMessage ? 'is-invalid row' : 'form-group row';
    return (
      <div className='container form-rule-editor-required'>
        <div className='tab-container container'>
          <div className='form-group row'>
            <label 
              className="col-md-4 col-sm-12 col-form-label"
              htmlFor='form_rule[name]'>Name for this rule:
            </label>
            <div className="col-md-8 col-sm-12">
              <input
                type='text'
                className={`form-control ${formRule.name.length === 0 ? 'is-invalid' : ''}`}
                name='form_rule[name]'
                value={formRule.name}
                maxLength='100'
                onChange={this.props.updateAttributeOnEvent} />
              <Fade
                mountOnEnter={true}
                unmountOnExit={true}
                  in={formRule.name.length === 0 || formRule.name.length > 100 }>
                <div className='alert alert-danger' role='alert'>
                  <i className='fas fa-info-circle'></i> &nbsp;
                  {formRule.name.length === 0 ? 'Name must be at least one non-space character long' : undefined }
                  {formRule.name.length > 100 ? 'Name must be no more than 100 characters' : undefined }
                </div>
              </Fade>
            </div>
          </div>

          <div className='form-group row'>
            <label 
              className="col-md-4 col-sm-12 col-form-label"
              htmlFor='form_rule[name]'>Rule Type:</label>
            <div className="col-md-8 col-sm-12">
              <select
                className='form-control'
                name='form_rule[rule_type]'
                disabled
                data-model-name={modelName}
                data-attribute-name='rule_type'
                value={formRule.rule_type}
                onChange={this.props.updateAttributeOnEvent}>
                <option value="">Select a rule type</option>
                {this.props.form_rule_types.map((rule_type, index) => {
                  return (<option 
                    value={rule_type}
                    key={index}>
                      {rule_type.replace("_", " ")}
                  </option>);
                })}
              </select>
              <input type="hidden" name='form_rule[rule_type]' value={formRule.rule_type} />
            </div>
          </div>

          { !this.props.form_rule.id 
            ? undefined 
            : <div className='form-group row'>
                <label
                  className='col-md-4 col-sm-12 col-form-label'
                  htmlFor='form_rule[name]'>Position order:
                </label>
                <div className='col-md-8 col-sm-12'>
                  <input
                    type='number'
                    className='form-control'
                    name='form_rule[position]'
                    data-model-name={modelName}
                    data-attribute-name='position'
                    value={formRule.position || ''}
                    onChange={this.props.updateAttributeOnEvent} />
                </div>
            </div>
          }
          <div className={taContainerClass}>
            <Fade
              mountOnEnter={true}
              unmountOnExit={true}
                in={showTargetFAErrorMessage}>
              <div className='alert alert-danger' role='alert'>
                <i className='fas fa-info-circle'></i> &nbsp;
                Form rules require at least one target attribute
              </div>
            </Fade>
              { SINGLE_TARGET_RULE_TYPES.includes(this.props.form_rule.rule_type) 
                ? this.renderTargetAttributeDropDownForSingle() 
                : this.renderTargetAttributeDropDownForMultiple()
              }
          </div>
          { 
            this.props.keenform.allow_custom_functions 
            ? this.renderTypeFunctionInput()
            : undefined
          }
        </div>

      </div>);
  }
}
